import { render, staticRenderFns } from "./OfferDocsForm.vue?vue&type=template&id=4c3dad10&scoped=true"
import script from "./OfferDocsForm.vue?vue&type=script&lang=js"
export * from "./OfferDocsForm.vue?vue&type=script&lang=js"
import style0 from "./OfferDocsForm.vue?vue&type=style&index=0&id=4c3dad10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3dad10",
  null
  
)

export default component.exports